import { useGetIdentity } from "@refinedev/core";
import {
    deductLocalAccountCredit,
    shouldSyncLocalAccountCredit,
} from "../utils/accountCredit";

export const useCredit = () => {
    const { data: user } = useGetIdentity();
    return user?.account?.credit ?? 0;
};

export const useDeductLocalAccountCredit = () => {
    const { data: user, refetch } = useGetIdentity<{
        account?: { id: number; billingMode?: string; credit?: number };
    }>();

    return (amount: number, orderAccountId: number): number | null => {
        const userAccountId = user?.account?.id;
        if (
            user?.account?.billingMode !== "prepaid" ||
            !shouldSyncLocalAccountCredit(orderAccountId, userAccountId)
        ) {
            return null;
        }
        const newCredit = deductLocalAccountCredit(amount);
        if (newCredit !== null) {
            void refetch();
        }
        return newCredit;
    };
};

